module.exports = __webpack_public_path__ + "img/bg5.aae3ef3a.png";